import oakleyLifestyleOne from '../../assets/OAKLEY2.webp';
import oakleyLifestyleTwo from '../../assets/OAKLEY4.webp';
import oakleyLifestyleThree from '../../assets/OAKLEY5.webp';

const LIFESTYLE_STORIES = [
  {
    eyebrow: 'Lifestyle edit',
    title: 'Built for sharp days in motion',
    description:
      'Clean silhouettes and performance-first lenses that feel at home from city streets to weekend movement.',
    primaryImage: oakleyLifestyleOne,
    secondaryImage: oakleyLifestyleTwo,
  },
  {
    eyebrow: 'Lifestyle edit',
    title: 'Frames that carry the whole look',
    description:
      'Everyday styling, sport influence, and confident lines that make the catalog feel more than purely functional.',
    primaryImage: oakleyLifestyleThree,
    secondaryImage: oakleyLifestyleOne,
  },
];

const CatalogLifestyleBlock = ({ sequenceIndex = 0 }) => {
  const story = LIFESTYLE_STORIES[sequenceIndex % LIFESTYLE_STORIES.length];

  return (
    <section className="grid gap-[12px] md:grid-cols-[minmax(0,1.25fr)_minmax(320px,0.75fr)] md:gap-[20px]">
      <article className="relative overflow-hidden rounded-[24px] bg-black shadow-product-normal">
        <img
          src={story.primaryImage}
          alt={story.title}
          className="h-[260px] w-full object-cover md:h-[360px]"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(0,0,0,0.12)_10%,rgba(0,0,0,0.72)_100%)]" />

        <div className="absolute inset-x-0 bottom-0 p-[18px] text-white md:p-[28px]">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/[0.72]">
            {story.eyebrow}
          </p>
          <h2 className="mt-[8px] max-w-[440px] text-[28px] font-bold leading-[1.05] tracking-tight md:text-[42px]">
            {story.title}
          </h2>
        </div>
      </article>

      <article className="flex flex-col rounded-[24px] border border-light-border-default bg-white p-[18px] shadow-product-normal dark:border-brand-border-default dark:bg-brand-surface md:p-[22px]">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-light-text-muted dark:text-brand-text-secondary">
            Catalog story
          </p>
          <p className="mt-[12px] text-[16px] leading-[1.7] text-light-text-secondary dark:text-brand-text-secondary md:text-[17px]">
            {story.description}
          </p>
        </div>

        <div className="mt-[18px] overflow-hidden rounded-[20px] bg-light-secondary dark:bg-brand-elevated">
          <img
            src={story.secondaryImage}
            alt={`${story.title} detail`}
            className="h-[180px] w-full object-cover md:h-[220px]"
            loading="lazy"
          />
        </div>

        <div className="mt-[14px] flex items-center justify-between rounded-[18px] bg-light-secondary px-[14px] py-[12px] text-[13px] font-medium text-light-text-secondary dark:bg-brand-elevated dark:text-brand-text-secondary">
          <span>Styled for movement</span>
          <span className="text-light-text-primary dark:text-brand-text-primary">Live catalog</span>
        </div>
      </article>
    </section>
  );
};

export default CatalogLifestyleBlock;
